<script lang="ts">
    import {fly, fade} from 'svelte/transition';
    import {dyData, modal} from 'general/store';
    import {ANIMATION_DURATION} from 'general/constants';
    import CrossWide from 'desktop/icons/CrossWide.svelte';

    import s from './style.module.css';
</script>

<div class={s.reminder} out:fly={{duration: ANIMATION_DURATION.REMINDER_CLOSE, y: 70, opacity: 0}}>
    <button
        type="button"
        class={s.reminderCross}
        aria-label="Close reminder"
        on:click|preventDefault={modal.closeReminder}
        in:fade={{duration: 0, delay: ANIMATION_DURATION.REMINDER_SHOW}}
    >
        <CrossWide />
    </button>
    <button
        type="button"
        class={s.reminderBody}
        aria-label="Open modal"
        on:click|preventDefault={modal.clickReminder}
    >
        <span class={s.reminderBox}>
            <span class={s.reminderText}>
                {$dyData.reminder?.[$modal.state]?.title}
            </span>
            <span class={s.reminderCoupon}>
                {$dyData.reminder?.[$modal.state]?.couponText
                    ? $dyData.reminder[$modal.state].couponText
                    : 'Get coupon'}
                <svg class={s.reminderArrow} width="14" height="11" viewBox="0 0 14 11" fill="none">
                    <path
                        d="M8 1L13 5.5M13 5.5L8 10M13 5.5L1 5.5"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
        </span>
    </button>
</div>
